export function Header() {
  return (
    <div className="header">
      <h1>Shop in style</h1>
      <p>With this shop hompeage template</p>
    </div>
  );
}
